<template>
    <div>
      <InventoryHeaderTab />
  
      <!-- Page Header -->
      <div class="page-header">
        <div>
          <h5 class="page-title">Create Product</h5>
          <p class="page-sub">Add a new product to your inventory</p>
        </div>
        <button type="button" @click="$router.go(-1)" class="btn-outline">
          <font-awesome-icon icon="arrow-left" /> Back
        </button>
      </div>
  
      <createProductForm />
    </div>
  </template>
  
  <style src="@vueform/multiselect/themes/default.css"></style>
  
  <script>
  import InventoryHeaderTab from "./component/inventoryheadertab.vue";
  import createProductForm  from "./component/createProductForm";
  
  export default {
    components: { InventoryHeaderTab, createProductForm },
  };
  </script>
  
  <style scoped>
  .page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 20px;
  }
  .page-title { font-size: 20px; font-weight: 700; color: #1a2b45; margin: 0 0 3px; }
  .page-sub   { font-size: 13px; color: #7a90b0; margin: 0; }
  
  .btn-outline {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    background: #fff;
    color: #1a2b45;
    border: 1px solid #dde5f0;
    font-size: 13px;
    font-weight: 500;
    padding: 9px 20px;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.15s;
  }
  .btn-outline:hover { background: #f4f7fb; }
  
  @media (max-width: 767px) {
    .page-header { flex-direction: column; align-items: stretch; }
    .btn-outline  { width: 100%; justify-content: center; }
  }
  </style>